export interface DevicePushToken {
  // Automatically assigned unique identifier.
  id: number; // Int,
  // The kind of the client application (mandatory).
  app: DevicePushTokenApp; // PushToken.App.Value,
  // The application bundle identifier. With each bundle a separate token is assigned.
  bundle: string; // String,
  // Unique identifier of the C5 device the application is using.
  deviceId: number; // Int,
  // UTC date in milliseconds for last modification or creation of the token. This field is read-only.
  modifiedOn: string; // DateTime,
  // The operating system of the client application (mandatory).
  os: DevicePushTokenOSType; // PushToken.OSType.Value,
  // Scope for token usage (mandatory).
  scope: DevicePushTokenScope[]; // Set[PushToken.Scope.Value],
  // The token issued by the cloud service. It will be automatically encrypted with AES-256 and converted to Base64.
  token: string; // String,
  // Unique identifier of the user who owns the token.
  userId: number; // Int
}

export enum DevicePushTokenApp {
  IM = 'IM',
  VOIP = 'VOIP',
}

export enum DevicePushTokenOSType {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  TEST = 'TEST',
}

export enum DevicePushTokenScope {
  CALL = 'CALL',
  CHAT = 'CHAT',
  FAX = 'FAX',
  PRESENCE = 'PRESENCE',
  VM = 'VM',
}
